import _ from 'lodash';

import { defaultOperation } from './constants';

import type { FunctionSchema } from 'app/developer-v3/platformSchema/function';
import type { RequestSchema } from 'app/developer-v3/platformSchema/request';

export function getValidPerformObjectForOperationType(
  operationType: string,
  perform: FunctionSchema | RequestSchema
) {
  const defaultPerformForOperationType =
    defaultOperation[operationType]?.perform ?? {};
  if (operationType === 'polling') {
    const performValue =
      typeof perform === 'string'
        ? perform
        : _.get(perform, 'url') || _.get(perform, 'source');
    return performValue
      ? perform
      : { ...defaultPerformForOperationType, ...perform };
  }

  // operationType is 'hook'
  return typeof perform?.source === 'string'
    ? perform
    : defaultPerformForOperationType;
}
